import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/callto365.webp';
import screenshot_target from '../../../images/letterfunnel/dennisderee.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dennis de Ree"
      firstname="Dennis"
      companyname="CallTo365"
      competition="ROGER365.io en Anywhere365"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dennisderee.js